import React, { forwardRef } from 'react';

export const SMSInput = forwardRef(
  ({ index, value, onChange, onKeyDown }, ref) => {
    return (
      <input
        ref={ref}
        value={value}
        onChange={(e) => onChange(index, e.target.value)}
        onKeyDown={(e) => onKeyDown(index, e)}
        type="text"
        inputMode="text"
        maxLength={1}
        autoFocus={index === 0}
        style={{
          width: '30px',
          border: 'transparent',
          textTransform: 'uppercase',
        }}
      />
    );
  }
);
